import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
// ui
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
//
import axios from "axios";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// components
import { useSearchParams, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { FormattedMessage, useIntl } from "react-intl";
import useGotoLogin from "../components/hook/useGotoLogin";
import TemplateHome from "../components/TemplateHome";
// utils
import fireDb from "../../api/firebase/realtime/utils";
import { StoreContext } from "../../store/StoreProvider";
import Act from "../../store/actions";
import fstDb from "../../api/firebase/firestore/utils";
import useLocaleRoute from "../../common/hooks/useLocaleRoute";
import urls from "../../api/project/ApiUrls";
import useModulePublic from "../hooks/useModulePublic";
import { ROUTE_PATH } from "../../config/CONSTANTS";
import { checkEmailExist } from "./service";
import fireAuth from "../../api/firebase/auth/utils";
import Carousel0TitleImg from "../../../images/home_carousel_0_title/home_carousel_0_title@2x.png";
import ButtonMain from "../../common/components/button/ButtonMain";
import Carousel0Img from "../../../images/home_carousel_0/home_carousel_0@2x.png";
import { checkUserInGroup } from "../sna/service/userGroupService";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

// style
const StyledContainer = styled(
  Container,
  {}
)(({ theme }) => ({
  paddingTop: "64px",
  paddingBottom: "160px",
}));

//
const InvitePage = () => {
  // route,intl
  const intl = useIntl();
  // router
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const inviteId = searchParams.get("inviteid");

  // style
  const classes = useStyles();
  // props

  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;

  // local state
  const [message, setMessage] = useState({ title: null, subtitle: null });
  const [isLoading, setIsLoading] = useState(true);
  const [invitation, setInvitation] = useState(null);
  // is invitation valid
  const [isInvitationNotValid, setIsInvitationNotValid] = useState(null);
  // 是否正在處理 invitation
  const [inProcessInvitation, setInProcessInvitation] = useState(false);
  // 正在處理 invitation 的訊息
  const [processMessage, setProcessMessage] = useState(null);
  // 是否成功加入
  const [isInvitationSuccess, setIsInvitationSuccess] = useState(false);

  // hook
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const isLoggedIn = fireAuth.isLoggedIn(user);

  const checkInvitation = async () => {
    if (!inviteId) {
      setIsLoading(false);
      setIsInvitationNotValid(false);
      setMessage({
        title: intl.formatMessage({
          id: "invite.invitation.notValid.title",
          defaultMessage: "OOPS!無效的邀請連結",
        }),
      });
      return;
    }
    const { success, error, data } = await fstDb.getInviteInfo({
      uid: inviteId,
    });
    // console.log("success", success);
    // console.log("error", error);
    // console.log("data", data);
    if (error || !(success && data)) {
      setIsLoading(false);
      setIsInvitationNotValid(false);
      setMessage({
        title: intl.formatMessage({
          id: "invite.invitation.notValid.title",
          defaultMessage: "OOPS!無效的邀請連結",
        }),
        subtitle: intl.formatMessage({
          id: "invite.invitation.notValid.subtitle",
          defaultMessage: "您的邀請連結已失效，請重新傳送群組邀請。",
        }),
      });
      return;
    }
    // store
    if (data) {
      setInvitation(data);
    }

    const { inviter, invitee, expTime, createTime, group } = data || {};

    // check if is expired
    if (Date.now() > data.expTime) {
      setIsLoading(false);
      setIsInvitationNotValid(false);
      setMessage({
        title: intl.formatMessage({
          id: "invite.invitation.notValid.title",
          defaultMessage: "OOPS!無效的邀請連結",
        }),
        subtitle: intl.formatMessage({
          id: "invite.invitation.notValid.subtitle",
          defaultMessage: "您的邀請連結已失效，請重新傳送群組邀請。",
        }),
      });

      return;
    }
    // invitation valid
    setIsInvitationNotValid(true);
    const checkUserRes = await checkEmailExist(invitee.email);

    // check if user is signup
    const isSignup = checkUserRes.success;

    if (isLoggedIn) {
      setIsLoading(false);
      const checkUserInGroupRes = await checkUserInGroup({
        email: invitee.email,
        groupId: group.uid,
      });
      const { userInGroup } = checkUserInGroupRes;
      console.log("checkUserInGroupRes", checkUserInGroupRes);

      if (userInGroup) {
        setInProcessInvitation(false);
        setIsInvitationSuccess(true);
        setMessage({
          title: intl.formatMessage(
            {
              id: "invite.invitation.title",
              defaultMessage: "歡迎加入「{group}」",
            },
            {
              group: group.displayName,
            }
          ),
          subtitle: intl.formatMessage(
            {
              id: "invite.invitation.subtitle",
              defaultMessage:
                "{user} 邀請您加入群組，\n接受邀請以共享社會網絡分析資源。",
            },
            {
              user: inviter.email,
            }
          ),
        });
        setProcessMessage(
          intl.formatMessage(
            {
              id: "invite.invitation.successful",
              defaultMessage: "你已成功加入群組「{group}」！",
            },
            { group: group.displayName }
          )
        );
      } else {
        setMessage({
          title: intl.formatMessage(
            {
              id: "invite.invitation.title",
              defaultMessage: "歡迎加入「{group}」",
            },
            {
              group: group.displayName,
            }
          ),
          subtitle: intl.formatMessage(
            {
              id: "invite.invitation.subtitle",
              defaultMessage:
                "{user} 邀請您加入群組，\n接受邀請以共享社會網絡分析資源。",
            },
            {
              user: inviter.email,
            }
          ),
        });
      }
      return;
    }

    if (isSignup) {
      // setIsLoading(false);
      setMessage({
        title: intl.formatMessage({
          id: "invite.invitation.redirection.toLogin",
          defaultMessage: "即將跳轉至登入頁面",
        }),
        subtitle: "",
      });
      setTimeout(() => {
        navigate(
          `${handleLocaleRoute(ROUTE_PATH.LogIn)}?backUrl=${handleLocaleRoute(
            ROUTE_PATH.InvitePage
          )}?${searchParams.toString()}`
        );
      }, 3000);
    } else {
      setIsLoading(false);
      setMessage({
        title: intl.formatMessage({
          id: "invite.invitation.redirection.toSignup",
          defaultMessage: "即將跳轉至註冊頁面",
        }),
        subtitle: "",
      });

      setTimeout(() => {
        navigate(
          `${handleLocaleRoute(ROUTE_PATH.Signup)}?backUrl=${handleLocaleRoute(
            ROUTE_PATH.InvitePage
          )}?${searchParams.toString()}`
        );
      }, 3000);
    }
  };

  //
  useEffect(() => {
    checkInvitation();
  }, [inviteId]);

  const onAcceptInvite = () => {
    if (!invitation) return;
    if (!user?.uid) return;

    const { inviter, invitee, expTime, createTime, group } = invitation || {};

    // console.log("inviter", inviter);
    // console.log("invitee", invitee);
    // console.log("group", group);
    setInProcessInvitation(true);
    setProcessMessage("processing...");
    // add user to group

    // update hsna-groups/{process.env.REACT_APP_WEB_MODE}/{uid}/members
    // { isMember: boolean, role: ENUM("admin", "editor", "reader")}
    fireDb.updateGroupMember({
      userId: user.uid,
      groupId: group.uid,
      data: {
        isMember: true,
        role: group.role,
        uid: user.uid,
      },
      onSuccess: () => {
        // update users/{uid of user}/groups/{uid of group}
        // { isMember: boolean, role: ENUM("admin", "editor", "reader"), uid: {uid of group}}

        fireDb.updateUserGroups({
          userId: user.uid,
          groupId: group.uid,
          data: {
            isMember: true,
            role: group.role,
            uid: group.uid,
            // 區分正式站/測試站
            appWebMode: process.env.REACT_APP_WEB_MODE,
          },
          onSuccess: async () => {
            // remove firestore/invitation
            // console.log("remove invitation doc in firestore");
            const delRes = await fstDb.deleteInviteInfo({ uid: inviteId });
            // console.log("delRes", delRes);
            // const { success, error, data } = delRes;
            setProcessMessage(
              intl.formatMessage(
                {
                  id: "invite.invitation.successful",
                  defaultMessage: "你已成功加入群組「{group}」！",
                },
                { group: group.displayName }
              )
            );
            setInProcessInvitation(false);
            setIsInvitationSuccess(true);
          },
          onError: () => {
            // error on updateUserGroups
            setMessage({
              title: "抱歉，發生問題",
              subtitle:
                "我們不確定發生甚麼問題，但重新整理頁面可能有幫助，或稍後再試一次。",
            });
            setInProcessInvitation(false);
          },
        });
      },
      onError: () => {
        // error on updateGroupMember
        setMessage({
          title: "抱歉，發生問題",
          subtitle:
            "我們不確定發生甚麼問題，但重新整理頁面可能有幫助，或稍後再試一次。",
        });
        setInProcessInvitation(false);
      },
    });
  };

  return (
    <TemplateHome>
      <StyledContainer>
        {isLoading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "120px",
              marginBottom: "56px",
            }}
          >
            <CircularProgress size={60} />
          </Box>
        )}
        {!isLoading && (
          <Grid container justifyContent="center" alignItems="center">
            {/* 左邊 */}
            <Grid
              item
              container
              justifyContent="flex-start"
              alignItems="center"
              sx={{ marginRight: "40px", width: "360px" }}
            >
              <Grid item>
                <Box mb={4}>
                  <Box mb={2}>
                    <Typography textAlign="left" variant="h4">
                      {message.title}
                    </Typography>
                  </Box>
                  <Typography textAlign="left" variant="h6">
                    {message.subtitle}
                  </Typography>
                </Box>
                <Box display="flex" columnGap={2} alignItems="center">
                  {!isInvitationSuccess && isInvitationNotValid && (
                    <ButtonMain
                      buttonProps={{
                        text: intl.formatMessage(
                          {
                            id: "invite.invitation.button.accept",
                            defaultMessage: "接受邀請",
                          },
                          {}
                        ),
                        size: "large",
                        variant: inProcessInvitation ? "loading" : "gradient",
                        disabled: !(user?.uid && inviteId),
                        // onClick 跟 href 不能同時使用(會觸發2次navigate)
                        onClick: onAcceptInvite,
                      }}
                    />
                  )}
                  {isLoggedIn && isInvitationSuccess && (
                    <ButtonMain
                      buttonProps={{
                        text: intl.formatMessage(
                          {
                            id: "invite.invitation.goto.sna",
                            defaultMessage: "開始使用",
                          },
                          {}
                        ),
                        size: "large",
                        variant: "gradient",
                        // onClick 跟 href 不能同時使用(會觸發2次navigate)
                        // onClick: onAcceptInvite,
                        href: `${
                          process.env.REACT_APP_WEB_DOMAIN
                        }${handleLocaleRoute(ROUTE_PATH.Sna)}`,
                      }}
                    />
                  )}
                  {processMessage && (
                    <Typography
                      textAlign="left"
                      variant="subtitle1"
                      sx={{
                        color: "text.secondary",
                      }}
                    >
                      {processMessage}
                    </Typography>
                  )}
                </Box>
              </Grid>
            </Grid>
            {/* 右邊 */}
            <Grid
              item
              justifyContent="center"
              alignItems="center"
              sx={{ width: "720px" }}
            >
              <Box>
                <img
                  src={Carousel0Img}
                  alt="home carousel interaction"
                  width={720}
                  height={520}
                />
              </Box>
            </Grid>
          </Grid>
        )}
      </StyledContainer>
    </TemplateHome>
  );
};

InvitePage.propTypes = {};

InvitePage.defaultProps = {};

export default InvitePage;
